<template>
  <div class="article-add">
    <PageHeader page-title="Redigera kontakt">
      <template #actions></template>
    </PageHeader>
    <Contact
      v-on:go-to-contact-details="goToContactDetails"
      :contactId="contactId"
      :editMode="true"
    />
  </div>
</template>

<script>
import PageHeader from "@/layouts/components/PageHeader.vue";
import Contact from "@/components/Contact.vue";

export default {
  components: {
    PageHeader,
    Contact,
  },
  data() {
    return { redirectPage: null };
  },
  props: ["contactId", "isNew"],
  methods: {
    deleteContact(contact) {
      this.$store.dispatch(
        "deleteContact",
        contact ? contact : this.$store.getters.getContactById(this.contactId)
      );
      this.goToContacts();
    },
    goToContacts() {
      this.redirectPage = "to";
      this.$router.push({ name: "contacts" });
    },
    goToContactDetails(contact) {
      this.redirectPage = "to";
      this.$router.push({
        name: "contact-details",
        params: { title: contact.title, id: contact.id },
      });
    },
    routeChangeAlert() {
      let title = "Vill du verkligen lämna sidan?";
      let text = this.isNew
        ? "Om du lämnar sidan utan att spara kommer kontakten och allt innehåll raderas."
        : "Om du lämnar sidan utan att spara kommer dina ändringar att försvinna.";
      let confirmButtonText = this.isNew ? "Radera kontakt" : "Lämna sidan";
      this.$swal({
        title: title,
        text: text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: confirmButtonText,
        cancelButtonText: "Avbryt",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (this.isNew) {
            this.deleteContact();
            this.$store.dispatch("editContact/clearContactEdit");
            this.$store.dispatch(
              "editUserPermissions/clearContactPermissionsEdit"
            );
          } else {
            this.goToContacts();
          }
        } else {
          this.redirectPage = null;
        }
      });
    },
  },
  mounted() {
    if (this.contactId) {
      this.$store.dispatch("editContact/initContactEdit", this.contactId);
      this.$store.dispatch(
        "editUserPermissions/initContactPermissionsEdit",
        this.contactId
      );
      return;
    }
    this.redirectPage = "to";
    this.$router.push({ name: "contacts" });
  },
  beforeRouteLeave(to, from, next) {
    if (this.redirectPage) {
      next();
    } else {
      this.redirectPage = to;
      this.routeChangeAlert();
    }
  },
};
</script>
